/* eslint-disable */
export const rewards = [
	{
		name: 'retentionPoints',
		displayName: 'Retention',
		total: 100,
		steps: [25, 50, 75],
		stepReward: 0.05,
		stepRewardFormat: '%',
		icon: 'retention_icon',
	},
	{
		name: 'engagementPoints',
		displayName: 'Engagement',
		total: 100,
		steps: [25, 50, 75],
		stepReward: 0.05,
		stepRewardFormat: 's',
		icon: 'engagement_icon',
	},
	{
		name: 'installsAmount',
		displayName: 'Installs',
		total: 100,
		steps: [25, 50, 75],
		stepReward: 0.05,
		stepRewardFormat: ' installs',
		icon: 'installs_icon',
	},
];

export const selfProgress = {
	retentionPoints: 0,
	engagementPoints: 0,
	installsAmount: 0,
};
